// --- CONFIGURATION ---
const SCRIPT_URL =
  'https://script.google.com/macros/s/AKfycbwnO9fvNSaAre8u_zp_hzMg6-Gd8nzyWsHQOj1dFUe6ieYNo9gfMj7Fv_2iKaepzz7V/exec';

const form = document.getElementById('cakeForm');
const submitBtn = document.getElementById('submitBtn');
const btnText = document.getElementById('btnText');
const btnSpinner = document.getElementById('btnSpinner');
const btnIcon = document.getElementById('btnIcon');
const messageBox = document.getElementById('formMessage');

function showError(message) {
  messageBox.textContent = message;
  messageBox.className = 'block mt-5 text-base text-red-600 font-medium';

  submitBtn.disabled = false;
  btnText.textContent = 'Apply';
  btnSpinner.classList.add('hidden');
  btnIcon.classList.remove('hidden');
}

form.addEventListener('submit', (e) => {
  e.preventDefault();

  const nameVal = form.name.value.trim();
  const emailVal = form.email.value.trim();
  const domainVal = form.domain.value.trim();
  const founderVal = form.founder.value.trim();

  form.name.value = nameVal;
  form.email.value = emailVal;
  form.domain.value = domainVal;
  form.founder.value = founderVal;

  // FRONTEND VALIDATION

  // A. Check for empty fields 
  if (!nameVal || !emailVal || !domainVal || !founderVal) {
    showError("Please fill out all required text fields.");
    return;
  }

  // B. Prevent basic Spreadsheet Injection
  const injectionChars = /^[=+\-@]/;
  if (injectionChars.test(nameVal) || injectionChars.test(domainVal) || injectionChars.test(founderVal)) {
    showError("Text fields cannot start with =, +, -, or @ symbols.");
    return;
  }

  // C. Validate Employees
  const employees = parseInt(form.employees.value, 10);
  if (isNaN(employees) || employees < 5 || employees > 30) {
    showError("Employee count must be a number between 5 and 30.");
    return;
  }

  // D. Validate Turnover Radio Buttons
  const turnoverSelected = form.querySelector('input[name="turnover"]:checked');
  if (!turnoverSelected) {
    showError("Please select your annual turnover.");
    return;
  }

  // E. Validate Required Checkboxes
  if (!form.accuracy.checked || !form['female-led'].checked || !form.qualified.checked || !form.terms.checked) {
    showError("You must agree to all required declarations to apply.");
    return;
  }

  // F. Check Turnstile Token
  const turnstileInput = form.querySelector('[name="cf-turnstile-response"]');
  if (!turnstileInput || !turnstileInput.value) {
    showError("Please wait a moment for the security check to complete.");
    return;
  }

  submitBtn.disabled = true;
  btnText.textContent = 'Sending...';
  btnSpinner.classList.remove('hidden');
  btnIcon.classList.add('hidden');
  messageBox.classList.add('hidden');

  const formData = new FormData(form);

  fetch(SCRIPT_URL, { method: 'POST', body: formData })
    .then((response) => {
      if (response.ok)
        return response.json().catch(() => ({ result: 'success' }));
      throw new Error('Network response was not ok');
    })
    .then((data) => {
      if (data.result === 'success') {
        form.reset();
        messageBox.textContent =
          "Thank you for applying! We've received your request, and it's now in review. Our team will follow up shortly with an update.";
        messageBox.className = 'block mt-5 lg:max-w-3/4';
      } else {
        throw new Error(data.error || 'Unknown error');
      }
    })
    .catch((error) => {
      console.error('Error!', error.message);
      messageBox.textContent = 'Something went wrong. Please try again.';
      messageBox.className = 'block mt-5';
    })
    .finally(() => {
      submitBtn.disabled = false;
      btnText.textContent = 'Apply';
      btnSpinner.classList.add('hidden');
      btnIcon.classList.remove('hidden');

      if (typeof turnstile !== 'undefined') {
        turnstile.reset();
      }
    });
});